module.exports = __webpack_public_path__ + "img/icon-favourite-outline.56d4bb98.svg";